import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Grid, Typography } from '@blueprint/ui';

const HelpVideo = () => {
    const { t } = useTranslation();
    const isIE = /*@cc_on!@*/ false || !!document.documentMode;
    return (
        <Grid container>
            <Box margin='100px 5vw 0px 5vw'>
                <Grid container>
                    <Box borderLeft='3px solid red' margin='0 0 2vw 0' paddingLeft='10px'>
                        <Typography variant='h1' className='page-title' tabIndex='-1'>
                            {t('helpVideo.sectionTitle')}
                        </Typography>
                    </Box>
                </Grid>
                <Grid container>
                    <Grid item xs={12} sm={8}>
                        <Box marginTop={['20px', '20px', '20px', '20px']}>
                            <video
                                src={process.env.PUBLIC_URL + '/videos/guestHelpVideo.mp4'}
                                width='100%'
                                height='auto'
                                style={{ width: `${isIE ? '1280px' : '100%'}`, height: `${isIE ? '720px' : 'auto'}` }}
                                controls
                                autoPlay
                            ></video>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default HelpVideo;
